import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import {useAuth} from "../hooks/useAuth";
import axios from "../axios/axios.js";

import { useNavigate, useLocation } from "react-router-dom";

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

import {motion} from "framer-motion";


function PersistLogin() {

    const [isLoading, setIsLoading] = useState(true);

    //todo animate dots sometime
    const [dots, setDots] = useState("...");
    const auth = useAuth();

    let location = useLocation();
    let navigate = useNavigate();

    useEffect(() => {

        const token = localStorage.getItem("token");

        //If we have a token but we didnt auth user yet, then authenticate
        //Note: We only do it once to grant access to the protected routes
        //If those make use of protected api's the bearer token will be automatically supplied
        if (token && !auth.user) {
            
            //yes
            new Promise((resolve, _) => {
                setTimeout(resolve, 1500);
            })
            .then(() => {
                axios.get("/authenticate", {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }).then(response => {
                    if (response.status == 200 && response.data.success) {
                        auth.setUser(response.data.username);
                        auth.setPermissionLevel(response.data.permissionLevel);
                        setIsLoading(false);
                    } 
                }).catch(exception => {
                    navigate("/login", {from: location, replace: true});
                });
            })
           
        } 
        
        //If we dont have a token, then navigate back to login
        else if (!token) {
            setIsLoading(false);
            navigate("/login", {from: location, replace: true});
        }

    }, []);

    return (
        <>
            {
            !auth.user 
                ? (
                    <motion.div
                        initial={{opacity: 0, scale: 0.9}}
                        animate={{opacity: 1, scale: 1}}
                        transition={{duration: 0.15}}
                        exit={{opacity: 0, scale: 2}}
                    >
                        <Box 
                            sx={{ 
                                display: 'flex',
                                height: "calc(100vh - 50px)",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                gap: "50px",
                                color: "#fff",
                                fontFamily: "Lato, sans-serif"
                            }}
                        >
                            <div className="icon-wrapper">
                                <FontAwesomeIcon className="icon" icon={faLock} />
                                <CircularProgress sx={{color: "#5a51b4"}} />
                            </div>
                            <div className="text-wrapper">
                                <h1>
                                    Authenticating
                                </h1>
                                <span className="dots">{dots}</span>
                            </div>
                            
                            
                        </Box>
                    </motion.div>
                    
                )
                : <Outlet />
            }
        </>
    )
}

export default PersistLogin;